import type { News } from './types';

type HeadlineNews = Pick<News, 'headline' | 'rephrased_headline'>;

// Keep canonical headlines in state for identity/linking and choose copy only
// at the user-facing rendering boundary.
export const displayNewsHeadline = (news: HeadlineNews) =>
  news.rephrased_headline?.trim() || news.headline;
